import { render, staticRenderFns } from "./LogNote.vue?vue&type=template&id=560bef96&scoped=true"
import script from "./LogNote.vue?vue&type=script&lang=js"
export * from "./LogNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560bef96",
  null
  
)

export default component.exports